import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormService } from '../../../app/parkifly-bookings/organizations/features/booking/components/form/service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { DateTimeFlightPickerComponent } from '../../../app/parkifly-bookings/datetimeflight-picker/datetimeflight-picker.component';
import { CommonModule, DatePipe } from '@angular/common';
import { SimpleSearchSelectComponent } from '../../../app/parkifly-bookings/components/simple-search-select/simple-search-select.component';
import { format } from 'date-fns';
import { FormControl } from '@angular/forms';
import { TextInputDataComponent } from '../../../app/parkifly-bookings/components/text-input/text-input.component';
import { BookingConfigService } from '../../../app/parkifly-bookings/services/booking-config.service';
import { TopNavbarComponent } from '../../../app/parkifly-bookings/organizations/components/top-navbar/top-navbar.component';
import { WelcomeComponent } from '../../../app/parkifly-bookings/components/welcome/welcome.component';
import { AuthService } from '../../../app/services/auth.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MaintenanceService } from '../../../app/services/maintenance.service';
import { LoginService } from '../../../app/services/login.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'app-quality-xpo-two-day-booking',
  imports: [
    CommonModule,
    TranslocoModule,
    DateTimeFlightPickerComponent,
    SimpleSearchSelectComponent,
    TextInputDataComponent,
    TopNavbarComponent,
    WelcomeComponent
  ],
  templateUrl: './quality-xpo-two-day-booking.component.html',
  styleUrl: './quality-xpo-two-day-booking.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [FormService, DatePipe]
})

export class QualityXpoTwoDayBookingComponent {

  site: string = '';
  parkingStartTime: any;
  parkingEndTime: any;
  selectType: string = '';
  searchData: any;
  routerState: any;
  discountCodeControl: FormControl = new FormControl('');
  isLoggedIn: boolean = false;
  orgId: any = '';
  showToggle: any = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _formService: FormService,
    private _router: Router,
    private bookingConfigService: BookingConfigService,
    public authService: AuthService,
    private dialog: MatDialog,
    private maintenanceService: MaintenanceService,
    private loginService: LoginService,
    public snackBar: SnackbarService,
    private translocoService: TranslocoService
  ) {
    const isAiden = this.router.url.includes('aiden');
    const selectedOrg = isAiden ? 'aiden-short-term' : 'quality-xpo-arlanda';
    this.bookingConfigService.setOrganization(selectedOrg);
    this.site = selectedOrg;
    this.selectType = 'simple';
    this.orgId = isAiden ? '55D7084D-3CF0-4CCC-9448-F924AFCDF3BC' : '942ce067-7848-4441-b746-8f6eed7395bb';

    this._formService.initForm(this.site);

    const routerState = this._router.getCurrentNavigation();
    const navState = routerState?.extras?.state || history.state;

    if (navState && (navState.departureDate || navState.arrivalDate || navState.searchData || navState.selectedParking)) {
      this.searchData = navState.searchData ? navState.searchData : navState;
      if (navState.selectedParking) {
        this._formService.selectedParking = navState.selectedParking;
      } else {
        this._formService.selectedParking = null;
        sessionStorage.removeItem('selectedParkingFromSearch');
        sessionStorage.removeItem('isFromCustomerHome');
      }
      if (this.searchData) {
        this.parkingStartTime = this.searchData.departureDate;
        this.parkingEndTime = this.searchData.arrivalDate;
        if (this.searchData.selectedParking) {
          this._formService.selectedParking = this.searchData.selectedParking;
        }
        if (this.searchData.discountCode) {
          this.discountCodeControl.setValue(this.searchData?.discountCode);
        }
      }
    } else {
      this._formService.selectedParking = null;
      sessionStorage.removeItem('selectedParkingFromSearch');
      sessionStorage.removeItem('isFromCustomerHome');
    }

  }

  ngOnInit(): void {
    if (this.site === 'quality-xpo-arlanda') {
      sessionStorage.setItem('isQuality2daysBooking', 'true');
      sessionStorage.removeItem('isAiden2daysBooking');
    } else if (this.site === 'aiden-short-term') {
      sessionStorage.setItem('isAiden2daysBooking', 'true');
      sessionStorage.removeItem('isQuality2daysBooking');
    }
    sessionStorage.removeItem('isParkingPermitUser');
    sessionStorage.removeItem('showSubscription');

    this.checkMaintenanceTime();

    this.route.queryParams.subscribe(params => {
      const fromVal = params['from'] || params['parking_start'] || params['departureDate'];
      const toVal = params['to'] || params['parking_end'] || params['arrivalDate'];

      if (fromVal) this.parkingStartTime = new Date(fromVal);
      if (toVal) this.parkingEndTime = new Date(toVal);
      if (params['discountCode'] || params['discount_code']) {
        this.discountCodeControl.setValue(params['discountCode'] || params['discount_code']);
      }

      if (this.parkingStartTime && this.parkingEndTime) {
        const search = this._formService.getForm()?.get('search');
        if (search) {
          search.patchValue({
            departureDatetime: this.parkingStartTime,
            arrivalDatetime: this.parkingEndTime
          });
        }
      }
    });

    const search = this._formService.getForm().get('search');
    search.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
      this.parkingEndTime = value;
      this.checkDurationLimit();
    })
    search.controls.departureDatetime.valueChanges.subscribe((value: any) => {
      this.parkingStartTime = value;
      this.checkDurationLimit();
    })

  }

  get isContinueButtonEnabled() {
    if (!this.parkingStartTime || !this.parkingEndTime || this.parkingEndTime <= this.parkingStartTime) {
      return false;
    }
    if (this.discountCodeControl.value?.toLowerCase().trim() === 'resa') {
      return false;
    }
    const diffInMs = this.parkingEndTime.getTime() - this.parkingStartTime.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);
    return diffInHours <= 720;
  }

  get isInvalidDiscountCode() {
    return this.discountCodeControl.value?.toLowerCase().trim() === 'resa';
  }

  checkDurationLimit() {
    if (this.parkingStartTime && this.parkingEndTime && this.parkingEndTime > this.parkingStartTime) {
      const diffInMs = this.parkingEndTime.getTime() - this.parkingStartTime.getTime();
      const diffInHours = diffInMs / (1000 * 60 * 60);
      if (diffInHours > 720) {
        const message = this.translocoService.translate('QUALITY_HOTEL.ERROR_MESSAGE');
        this.snackBar.openSnackBar(message, 'OK');
      }
    }
  }

  goToBookingForm() {
    if (this.authService.loggedIn()) {
      this.navigateToBooking();
    } else {
      if (this.loginService.showPopupValue === false) {
        this.navigateToBooking();
      }
      else {
        const dialogRef = this.dialog.open(WelcomeComponent, {
          width: '500px',
          disableClose: false,
          panelClass: 'welcome-dialog'
        });

        dialogRef.afterClosed().subscribe(() => {
          this.navigateToBooking();
        });
      }
    }
  }

  navigateToBooking() {
    const search = this._formService.getForm().get('search');
    let parking_start = format(this.parkingStartTime, 'yyyy-MM-dd HH:mm')
    let parking_end = format(this.parkingEndTime, 'yyyy-MM-dd HH:mm')
    let queryParams: any = {
      parking_start: parking_start || undefined,
      parking_end: parking_end || undefined,
    };
    if (this.discountCodeControl.value.length) {
      queryParams['discount_code'] = this.discountCodeControl.value;
    }
    this.router.navigate(['parkifly', this.site, 'booking', queryParams], {
      state: {
        selectedParking: this.searchData?.selectedParking || this._formService.selectedParking || history.state?.selectedParking
      }
    });
  }

  checkMaintenanceTime() {
    this.maintenanceService.checkMaintenanceTime();
  }

}

@Component({
  selector: 'app-maintenance-dialog',
  imports: [TranslocoModule],
  template: `
    <div class="maintenance-dialog">
    <div class="flex justify-center py-4">
        <svg width="106" height="117" viewBox="0 0 106 117" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M74.0049 23.325L58.7525 11.805C55.3515 9.23619 50.6589 9.2362 47.2578 11.805L32.0055 23.325L13.8482 29.8366C9.49901 31.3963 6.89367 35.8495 7.6651 40.405L10.6508 58.0367L7.6651 75.6684C6.89366 80.2239 9.49902 84.6771 13.8482 86.2368L32.0055 92.7484L47.2578 104.268C50.6589 106.837 55.3515 106.837 58.7525 104.268L74.0049 92.7484L92.1622 86.2368C96.5114 84.6771 99.1167 80.2239 98.3453 75.6684L95.3595 58.0367L98.3453 40.405C99.1167 35.8495 96.5114 31.3963 92.1622 29.8366L74.0049 23.325Z"
                fill="#FFEDE3" stroke="#FFF5F5" stroke-width="13.6229" />
            <circle cx="52" cy="57" r="10" stroke="#DC0032" stroke-width="2" fill="#FFEDEE" />
            <line x1="47" y1="52" x2="57" y2="62" stroke="#DC0032" stroke-width="2" stroke-linecap="round" />
            <line x1="57" y1="52" x2="47" y2="62" stroke="#DC0032" stroke-width="2" stroke-linecap="round" />

        </svg>
    </div>
      <h2>{{ 'MAINTENANCE.TITLE' | transloco }}</h2>
      <p>{{ 'MAINTENANCE.MESSAGE' | transloco }} {{ data?.endTime }}.</p>
      <div class="language-toggle">
            <div>
            <button class="
            w-[48px]
            h-[48px]
            " (click)="toggleLanguage()" style="outline: none;">
                <img src="{{languageImageSource}}" alt="toggle language" class="w-[25px] h-[25px]">
            </button>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .maintenance-dialog {
      padding: 24px;
      text-align: center;
      position: relative;
    }
    h2 {
      margin-bottom: 16px;
      color: #f44336;
    }
  `]
})
export class MaintenanceDialogComponent {
  currentLang = 'sv';

  languageImageSources: { [key: string]: string } = {
    en: "../../../../../assets/img/flag-button-round-250-EN.png",
    sv: "../../../../../assets/img/flag-button-round-250-SV.png",
  };

  languageImageSource: string = '';

  constructor(private _translocoService: TranslocoService,
    @Inject(MAT_DIALOG_DATA) public data: { endTime: string }
  ) {
    this.currentLang = this._translocoService.getActiveLang();
    this.languageImageSource = this.currentLang === 'en' ? this.languageImageSources['sv'] : this.languageImageSources['en'];
  }

  toggleLanguage() {

    let activeLanguage = this._translocoService.getActiveLang();

    if (activeLanguage == 'sv') {
      this._translocoService.setActiveLang('en');
    } else {
      this._translocoService.setActiveLang('sv');
    }

    activeLanguage = this._translocoService.getActiveLang();
    this.languageImageSource = activeLanguage === 'en' ? this.languageImageSources['sv'] : this.languageImageSources['en'];

  }
}